import React from "react";
import { IMAGES } from "../assets/img/ImageIndex";
import { Link } from "react-router-dom";

const ProcessAreaStep = () => {
  return (    
    <div className="row">
        <div className="step-section">
            <div className="process-single-item">
                <div className="d-flex align-items-center nich">
                    <div>
                        <span>01</span>
                    </div>
                    <img decoding="async" src={IMAGES.rightLongArrow} alt="arrow"/>
                </div>
                <h3>Apply</h3>
                <p>Apply online and secure financing for your business</p>
            </div>
        </div>
        <div className="step-section">
            <div className="process-single-item">
                <div className="d-flex align-items-center nich">
                    <div>
                        <span>02</span>
                    </div>
                    <img decoding="async" src={IMAGES.rightLongArrow} alt="arrow"/>
                </div>
                <h3>Qualify</h3>
                <p>6 months in business, 550 credit score, business checking account</p>
            </div>
        </div>
        <div className="step-section">
            <div className="process-single-item">
                <div className="d-flex align-items-center nich">
                    <div>
                        <span>03</span>
                    </div>
                    <img decoding="async" src={IMAGES.rightLongArrow} alt="arrow"/>
                </div>
                <h3>Approval</h3>
                <p>Get approval within one business day</p>
            </div>
        </div>
        <div className="step-section">
            <div className="process-single-item">
                <div className="d-flex align-items-center nich">
                    <div>
                        <span>04</span>
                    </div>
                    <img decoding="async" src={IMAGES.rightLongArrow} alt="arrow"/>
                </div>
                <h3>Funding</h3>
                <p>In most cases, get funds for your business within 24 hours</p>
            </div>
        </div>
        <div className="step-section">
            <div className="process-single-item">
                <div className="d-flex align-items-center nich">
                    <div>
                        <span>05</span>
                    </div>
                </div>
                <h3>Renewals</h3>
                <p>If your payments are up to date and 65% or more is paid off.</p>
            </div>
        </div>

        <div className="col-lg-12">
            <div className="border-top pt-4 text-center">
                <Link to="https://app.envocapital.com" className="btn border-0" target="_blank">
                    Apply Now
                </Link>
            </div>
        </div>
    </div>
  );
};

export default ProcessAreaStep;
